import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './VoiceDetails.css'; // Import the custom CSS file

const VoiceDetails = () => {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-3 box">
          <div className="box-header bg-red text-white">
            Categories I can voice on
          </div>
          <ul className="list-unstyled box-content">
            <li>Commercials/ Ads</li>
            <li>Explainers</li>
            <li>Narrations</li>
            <li>Educational</li>
            <li>Business/ Corporate</li>
            <li>IVR</li>
            <li>Television</li>
          </ul>
        </div>
        <div className="col-md-3 box">
          <div className="box-header bg-red text-white">
            Vocal Characteristics
          </div>
          <ul className="list-unstyled box-content">
            <li>Female</li>
            <li>Teen</li>
            <li>Young</li>
            <li>Indian Accent</li>
            <li>Middle Aged</li>
            <li>Neutral Accent</li>
          </ul>
          <div className="box-subheader bg-black text-white">Languages I voice over </div>
        <ul className="list-unstyled box-content">
        <li>Hindi</li>
        <li>English</li>
          </ul>
        </div>
        
        <div className="col-md-3 box">
          <div className="box-header bg-red text-white">
            Gears
          </div>
          <div className="box-subheader bg-black text-white">Turnaround Time:</div>
          <div className="box-content">24 hours - 2 days</div>
          <div className="box-subheader bg-black text-white">Microphone:</div>
          <div className="box-content">Audio Technica, ATR-2100X Microphone</div>
          <div className="box-subheader bg-black text-white">Editing:</div>
          <div className="box-content">Audacity</div>
        </div>
        <div className="col-md-3 box">
          <div className="box-header bg-red text-white">
            Happy Clients
          </div>
          <ul className="list-unstyled box-content">
            <li>CavinKare</li>
            <li>Bru Coffee</li>
            <li>Haus and Kinder</li>
            <li>Hindware</li>
            <li>And More</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VoiceDetails;


// .col-md-3{
//     box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
//     padding: 15px;
//     background-color: white;
//     margin:5px;
//     border-radius: 2px;
    


//   }

// .box-header {
//     padding: 5px 10px;
//     font-size: 1.2em;
//     font-weight: bold;
//     text-align: center;
//     background-color: #ff0000;
//     border-radius: 5px;
//   }
  
//   .box-content {
//     padding: 10px;
//     font-size: 1em;
//     color: black;
//   }
  
//   .box-subheader {
//     padding: 5px 10px;
//     font-size: 1em;
//     font-weight: bold;
//     margin-top: 10px;
//     background-color: black;
//     border-radius: 5px;
//   }
  
//   ul.box-content {
//     list-style-type: disc;
//     padding-left: 20px;
//   }
  